import { Accordion, Box, MultiSelect, Stack, Text } from '@mantine/core';
import React from 'react';
import styles from './styles.module.css';
import { Controller } from 'react-hook-form';
import SegmentedInput from 'components/SegmentedInput';
import { YES_NO_OPTION } from 'constant/course';

interface IndicatorStandardFormProps {
  control: any;
  errors: any;
  limIndicatorValue?: boolean;
}

const IndicatorStandardForm: React.FC<IndicatorStandardFormProps> = ({
  control,
  errors,
  limIndicatorValue
}) => {
  return (
    <Accordion.Item className={styles.accordionItem} value='indicatorStandard'>
      <Accordion.Control className={styles.accordionControl}>
        Indicator & Standard
      </Accordion.Control>
      <Accordion.Panel className={styles.accordionPanel}>
        <Stack gap='lg' py={16}>
          <Box>
            <Text c={'dark'} fz={'md'} fw={600} mb={4}>
              Indicators
            </Text>

            <Controller
              name='limIndicator'
              control={control}
              render={({ field }) => (
                <SegmentedInput
                  label='Learning Impact Measurement (LIM)'
                  options={YES_NO_OPTION}
                  value={
                    YES_NO_OPTION.find((item) => (field.value ? 'Yes' : 'No') === item.label)
                      ?.value || '1'
                  }
                  onChange={(value: string) =>
                    field.onChange(
                      YES_NO_OPTION.find((item) => item.value === value)?.label === 'Yes'
                        ? true
                        : false
                    )
                  }
                />
              )}
            />
            {limIndicatorValue && (
              <Box my={12}>
                <Controller
                  name='c'
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      label={'Bloom`s Taxonomy'}
                      placeholder='Select measurement level'
                      data={[...Array(6)].map((_, i) => `C${i + 1}`)}
                      searchable
                      error={errors.c?.message}
                      required
                      withAsterisk
                      {...field}
                    />
                  )}
                />
              </Box>
            )}

            <Controller
              name='liaIndicator'
              control={control}
              render={({ field }) => (
                <SegmentedInput
                  label='Learning Impact Assessment (LIA)'
                  options={YES_NO_OPTION}
                  value={
                    YES_NO_OPTION.find((item) => (field.value ? 'Yes' : 'No') === item.label)
                      ?.value || '1'
                  }
                  onChange={(value: string) =>
                    field.onChange(
                      YES_NO_OPTION.find((item) => item.value === value)?.label === 'Yes'
                        ? true
                        : false
                    )
                  }
                />
              )}
            />
          </Box>
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default IndicatorStandardForm;
